<template>
  <div class="editHoliday">
    <Card class='editHolidayCont'>
      <Divider orientation="left" :style="{color:'rgba(0, 0, 0, 0.65)'}">基本设置</Divider>
      <Form ref="holidayData" :model="holidayData" :rules="ruleValidate" :label-width="120">

        <FormItem label="假期名称" prop="vacationName">
          <template v-if="holidayData.isCompensation">
            <label>{{ holidayData.vacationName }}</label>
          </template>
          <template v-else>
            <Input prefix="ios-paper-plane" v-model="holidayData.vacationName"
                   placeholder="请输入假期名称" :style="{width:'200px'}"/>
          </template>
        </FormItem>
        <FormItem label="是否启用" prop="isUse">
          <i-switch size="large" v-model="holidayData.isUse" @on-change="enableVacation">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="最小请假单位">
          <Select v-model="holidayData.minVacationUnitEnumId" style="width:200px">
            <Option v-for="item in minVacationUnitList" :value="item.id" :key="item.id">{{ item.itemName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="假期时长计算方式">
          <Select v-model="holidayData.calTypeEnumId" style="width:200px">
            <Option v-for="item in calTypeList" :value="item.id" :key="item.id">{{ item.itemName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否带薪假">
          <i-switch size="large" v-model="holidayData.isPaidLeave">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
          <span class="notes">选择带薪假，不扣减工资</span>
        </FormItem>
        <Divider orientation="left" :style="{color:'rgba(0, 0, 0, 0.65)'}">假期余额设置</Divider>
        <FormItem label="启用假期余额">
          <i-switch size="large" v-model="holidayData.isUseBalance" @on-change="enableBalance">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="余额发放方式" v-show="holidayData.isUseBalance">
          <Select v-model="holidayData.balanceIssueEnumId" style="width:200px" @on-change="changeNote">
            <template v-if="holidayData.isCompensation">
              <Option v-for="item in balanceIssueList" v-if="item.itemName === '加班时长转入'"
                      :value="item.id" :key="item.id">{{ item.itemName }}</Option>
            </template>
            <template v-else>
              <Option v-for="item in balanceIssueList" :value="item.id" :key="item.id">{{ item.itemName }}</Option>
            </template>
          </Select>
          <span class="notes">{{holidayData.balanceIssueDescribe}}</span>
        </FormItem>
        <div v-show="holidayData.isUseBalance">
          <FormItem ref='entryYearRow' v-show="showEntryYear">
            <Row v-for="(item,index) in holidayData.entryYearVacationDOS" :key="item.id">
              <Col span="8">
                <Icon type="ios-remove-circle-outline" size="25" @click="removeEntryYear(index)"/>
                入职年限<InputNumber v-model="item.entryYearLower" :max="50" :min="0" :value="1" :style="{width:'50px'}"/>
                --<InputNumber v-model="item.entryYearUpper" :max="50" :value="1" :style="{width:'50px'}"/>
                年, 享受假期余额
                <InputNumber v-model="item.vacationDays" :max="30" :min="1" :value="1" :style="{width:'50px'}">
                </InputNumber>天
                <Icon type="ios-add-circle-outline" size="25" @click="addEntryYear()"/>
              </Col>
            </Row>
          </FormItem>
          <FormItem  v-show="showEveryYear">
            每个员工每年发放<InputNumber v-model="holidayData.vacationDays"  :max="30" :min="1" :value="0"
                                 :style="{width:'50px'}" size="small"></InputNumber> 天
          </FormItem>
        </div>
        <Divider v-show="holidayData.isUseBalance"></Divider>
        <FormItem label="有效期规则" v-show="holidayData.isUseBalance">
          <Select v-model="holidayData.indateTypeEnumId" style="width:200px">
            <Option v-for="item in indateTypeList" :value="item.id" :key="item.id">{{ item.itemName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否允许延长有效期" v-show="holidayData.isUseBalance">
          <Row>
            <Col span="6">
              <i-switch size="large" v-model="holidayData.isProlongIndate">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </Col>
            <Col span="8" v-show="holidayData.isProlongIndate">
              允许有效期延长天数 <InputNumber :max="365" :min="0" :value="1" :style="{width:'50px'}" size="small"
                                     v-model='holidayData.prolongDays'></InputNumber> 天
              <span class="notes">填写0天表示不允许延长</span>
            </Col>
          </Row>
        </FormItem>
        <Divider />
        <FormItem class='bottom'>
          <Button @click="handleReset()" size='large' class='button'>取消</Button>
          <Button type="primary" @click="handleSubmit('holidayData')" size='large' class='button'>保存</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>


<script>
  import { Message } from 'element-ui'

  export default {
    components:{
    },
    created(){
      this.initData();
    },
    data() {
      return {
        //下拉框数据
        minVacationUnitList: [],
        calTypeList: [],
        balanceIssueList: [],
        indateTypeList: [],
        holidayData: {
          id: 0,
          isUse: true,
          vacationName: '', //假期名称
          minVacationUnitEnumId: 0, //最小单位
          calTypeEnumId: 0, //计算方式
          isUseBalance: false, //是否启用假期余额
          indateTypeEnumId: 0, //有效期规则
          isProlongIndate: false ,//是否延长有效期
          prolongDays:0,//有效期延长天数
          balanceIssueEnumId: 0,//余额发放方式的注释
          balanceIssueDescribe: '',
          isPaidLeave: false,//是否带薪假
          workTime:'',//入职时间
          entryYearVacationDOS:[{
            "entryYearLower": 1,
            "entryYearUpper": 1,
            "vacationDays": 1,
          }],//入职年限对应享受年假天数
          delEntryYearVacationDOS: [],//被删除的入职年限对应享受年假天数
          vacationDays: 0,//发放天数
          isCompensation: false,
        },
        showEntryYear: false,
        showEveryYear: false,
        ruleValidate: {
          vacationName: [{
            required: true,
            message: '请填写假期名称',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      initData() {
        this.getEnumItemList();
        this.holidayData.id = this.$route.query.id;
        if(this.holidayData.id){
          this.$api.getVacationDetail(this.holidayData.id).then((res) => {
            this.holidayData = res;
            if (res.entryYearVacationDOS == null || res.entryYearVacationDOS.length === 0) {
              this.holidayData.entryYearVacationDOS = [];
              this.addEntryYear();
            }
            this.holidayData.delEntryYearVacationDOS = [];
            this.$api.getEnumListByName('余额发放方式').then((res) =>{
              this.balanceIssueList = res;
              this.changeNote();
            });
          }).catch((error) => {
            this.$Message.error({
              content: error.response.data.detail,
              duration: 2
            });
          })
        } else {
          this.$api.getEnumListByName('余额发放方式').then((res) =>{
            if (this.idIsEmpty(this.holidayData.balanceIssueEnumId)) {
              this.holidayData.balanceIssueEnumId = res[0].id;
            }
            this.balanceIssueList = res;
            this.changeNote();
          });
        }
      },
      getEnumItemList() {
        this.$api.getEnumListByName('最小请假单位').then((res) =>{
          if (this.idIsEmpty(this.holidayData.minVacationUnitEnumId)) {
            this.holidayData.minVacationUnitEnumId = res[0].id;
          }
          this.minVacationUnitList = res;
        });
        this.$api.getEnumListByName('假期时长计算方式').then((res) =>{
          if (this.idIsEmpty(this.holidayData.calTypeEnumId)) {
            this.holidayData.calTypeEnumId = res[0].id;
          }
          this.calTypeList = res;
        });
        this.$api.getEnumListByName('有效期规则').then((res) =>{
          if (this.idIsEmpty(this.holidayData.indateTypeEnumId)) {
            this.holidayData.indateTypeEnumId = res[0].id;
          }
          this.indateTypeList = res;
        });
      },
      changeNote() {
        if (this.balanceIssueList.length > 0) {
          this.balanceIssueList.forEach(balanceIssue => {
            if (this.holidayData.balanceIssueEnumId === balanceIssue.id) {
              this.holidayData.balanceIssueDescribe = balanceIssue.describe;
              switch (balanceIssue.itemCode){
                case 'manualIssue':
                  this.showEntryYear = false;
                  this.showEveryYear = false;
                  break;
                case 'autoIssueByEntry':
                  this.showEveryYear = false;
                  this.showEntryYear = true;
                  break;
                case 'autoIssue':
                  this.showEntryYear = false;
                  this.showEveryYear = true;
                  break;
                default:
                  this.showEntryYear = false;
                  this.showEveryYear = false;
              }
            }
          })
        }
      },
      addEntryYear() {
        let entryYearObj = {
          "entryYearLower": 1,
          "entryYearUpper": 1,
          "vacationDays": 1,
        };
        this.holidayData.entryYearVacationDOS.push(entryYearObj);
      },
      removeEntryYear(index) {
        if (this.holidayData.entryYearVacationDOS.length === 1) {
          //必须保留一条入职年限假期天数对照记录
          return;
        }
        if (this.holidayData.entryYearVacationDOS[index].hasOwnProperty('id')) {
          this.holidayData.delEntryYearVacationDOS =
            this.holidayData.delEntryYearVacationDOS.concat(this.holidayData.entryYearVacationDOS[index]);
        }
        this.holidayData.entryYearVacationDOS.splice(index,1);
      },
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.saveVacationBalance(this.holidayData)
              .then(() => {
                Message({message: '保存成功', type: 'success'});
                this.$router.push({path:'/attendanceSettings/vacationRules'});
              });
          } else {
            this.$Message.error('请填写完整所需的信息！');
          }
        })
      },
      handleReset() {
        this.$router.back();
      },
      enableVacation(status) {
        if (!status) {
          this.$alert('禁用后，员工不能请假，余额将清零，并且假期管理中员工已有的请假记录也不再显示，请谨慎操作！', '提示', {
            confirmButtonText: '确定',
          });
        }
      },
      enableBalance(status) {
        if (this.idIsEmpty(this.holidayData.balanceIssueEnumId)) {
          this.holidayData.balanceIssueEnumId = this.balanceIssueList[0].id;
        }
        if (this.idIsEmpty(this.holidayData.indateTypeEnumId)) {
          this.holidayData.indateTypeEnumId = this.indateTypeList[0].id;
        }
        if (!status) {
          this.$alert('禁用后，余额将清零，请谨慎操作！', '提示', {
            confirmButtonText: '确定',
          });
        }
      },
      idIsEmpty(object) {
        return object === 0 || object === "0" || object === undefined
      }
    }
  }
</script>
<style scoped>
  @import url("../common/layout.css");
  .notes{
    padding-left: 10px;
    color:#a3a4a6;
  }
</style>

